export default __webpack_public_path__ + "static/media/login-illustration-mobile.79d325f7.svg";